/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useState, useEffect, useCallback } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useGetComment = (commentCode: string) => {
  const [comment, setComment] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const { token } = useAuthContext();

  const { reset } = useAbortController();

  const getComment = useCallback(async () => {
    if (!commentCode || !token) {
      return;
    }
    setLoading(true);
    const url = process.env.REACT_APP_COMMENT + commentCode;

    const controller = reset();
    const config = { signal: controller.signal };

    const headers = {
      'Session-Token': token,
      'Content-Type': 'application/json',
    };

    try {
      let response = await axiosCall({ url: url, method: 'get' }, config, headers);
      setErrorMessage('');
      setComment(response);
      setLoading(false);
    } catch (error) {
      setErrorMessage('Error Loading Comment:' + commentCode);
      setLoading(false);
      console.error(error.message);
    }
  }, [commentCode, reset, token]);

  useEffect(() => {
    getComment();
  }, [getComment]);

  return {
    comment: comment,
    commentErrorMessages: errorMessage,
    loadingComment: loading,
  };
};

export default useGetComment;
